module.exports = "<router-outlet></router-outlet>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/recursos-humanos/recursos-humanos.component.html
 ** module id = 171
 ** module chunks = 0
 **/